export default {
  templates: {
    // Traditional Wedding Tasks
    'choose-venue': {
      title: 'Elegir el lugar de la recepción',
      description: 'Investigar y visitar diferentes lugares para la ceremonia y la recepción'
    },
    'define-budget': {
      title: 'Definir el presupuesto global',
      description: 'Establecer un presupuesto detallado para cada partida de gastos'
    },
    'choose-date': {
      title: 'Elegir la fecha',
      description: 'Fijar la fecha de la boda según la disponibilidad del lugar y los proveedores principales'
    },
    'book-venue': {
      title: 'Reservar el lugar de la recepción',
      description: 'Visitar y reservar el lugar para la ceremonia y la recepción'
    },
    'choose-photographer': {
      title: 'Elegir el fotógrafo',
      description: 'Investigar y conocer fotógrafos para seleccionar el de tu boda'
    },
    'choose-caterer': {
      title: 'Elegir el catering',
      description: 'Investigar y seleccionar un catering para la recepción'
    },
    'choose-florist': {
      title: 'Elegir el florista',
      description: 'Seleccionar un florista para las decoraciones de la ceremonia y recepción'
    },
    'choose-music': {
      title: 'Elegir la música',
      description: 'Seleccionar músicos o DJ para la ceremonia y la recepción'
    },
    'choose-transport': {
      title: 'Elegir el transporte',
      description: 'Reservar transporte para el día de la boda'
    },
    'choose-attire': {
      title: 'Elegir el vestuario',
      description: 'Comprar el vestido de novia y el traje del novio'
    },
    'choose-beauty': {
      title: 'Elegir servicios de belleza',
      description: 'Reservar servicios de peluquería y maquillaje para el día de la boda'
    },
    'send-invitations': {
      title: 'Enviar invitaciones',
      description: 'Diseñar y enviar invitaciones de boda a los invitados'
    },
    'plan-honeymoon': {
      title: 'Planificar la luna de miel',
      description: 'Investigar y reservar destino de luna de miel'
    },
    'legal-formalities': {
      title: 'Formalidades legales',
      description: 'Completar todos los requisitos legales para el matrimonio'
    }
  }
};
